import { imax, mulBp, withinRange } from '../math/fixed.ts';
import type { BattleState } from '../types.ts';
import { damageEnemy, ev } from './combat.ts';
import { emptyPlayerStats, makeHero } from './create.ts';

/**
 * The night of the bell at the bastion (El Párpado 4, docs/SAGAS.md): the allies the group made on the way come one at
 * a time, at the worst moments: the next one once the keep is under its share of life, or at its time, whichever comes
 * first. Each comes in as a hero of their own (a spectre's way of fighting), and their way in hits and stuns the
 * nightmares round where they come: Gaspar at the gate, the lanterns up a road, the boars over the edge.
 */

export const alliesTick = (s: BattleState): void => {
  const r = s.rules?.allies;
  if (!r) return;
  const st = (s.allies ??= { n: 0 });
  if (!s.started || st.n >= r.come.length) return;
  const at = r.at[st.n] ?? 0x7fffffff;
  const hurt = r.hurtBp[st.n] ?? 0;
  if (s.waveT < at && mulBp(s.keep.maxHp, hurt) < s.keep.hp) return;
  const a = r.come[st.n] as (typeof r.come)[number];
  st.n++;
  const h = makeHero(s, { pid: a.pid, name: a.name, cls: a.cls, level: a.level, control: 'ghost', powerBp: a.powerBp, post: a.post });
  h.x = h.destX = h.ax = a.x;
  h.y = h.destY = h.ay = a.y;
  s.heroes.push(h);
  s.stats.players[a.pid] = emptyPlayerStats();
  for (const e of s.enemies) {
    if (e.hp <= 0 || e.kind === 'boneWall' || !withinRange(e.x, e.y, a.x, a.y, r.blow.r)) continue;
    damageEnemy(s, e, r.blow.foe, { pid: a.pid, ignoresArmor: true, noReact: true });
    e.stun = imax(e.stun, r.blow.stun);
  }
  ev(s, { t: 'ally', npc: a.pid.slice(4), x: a.x, y: a.y });
};
